import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class HousekeepingServices extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Housekeeping Services | Professional Home Cleaning"
          description="Professional housekeeping services for homes and apartments. Reliable and experienced cleaners."
          keywords="housekeeping services, home cleaning services, domestic cleaning services, professional housekeepers"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Professional Housekeeping Services
                </h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Professional Housekeeping Services
                          </h4>
                          <p>
                            Our housekeeping services provide consistent home
                            maintenance cleaning tailored to busy households. We
                            offer regular weekly and fortnightly cleaning plans
                            designed to keep your home clean and organised.
                          </p>
                          <div className="dlab-info m-t30">
                            <h4 className="dlab-title m-t0">
                              What's included in Housekeeping:
                            </h4>
                            <ul className="list-check primary">
                              <li>Dusting and wiping all surfaces</li>
                              <li>Vacuuming carpets and mopping floors</li>
                              <li>Bathroom cleaning and sanitisation</li>
                              <li>Kitchen cleaning and tidy-up</li>
                              <li>General tidying and organisation</li>
                            </ul>
                          </div>
                          <p>
                            By hiring a professional housekeeper, you save time,
                            maintain a hygienic environment, and reduce the
                            stress of daily chores.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default HousekeepingServices;
